import { NO_INFORMATION } from "@/data/placeholders";
import { Posting, Project, User_Profile } from "@/generated/graphql";

export default function getLocationInfo(withLocationEntity: Posting | Project | User_Profile, fullLocation: boolean = false) {
  const { city, country } = withLocationEntity;
  const commonLocation = [city, country];

  if (!fullLocation) {
    return getLocationOrPlaceholder(commonLocation);
  }
  const { state } = withLocationEntity;
  commonLocation.splice(1, 0, state);
  return getLocationOrPlaceholder(commonLocation);
};

export function getLocationOrPlaceholder(locationArray: (string | null | undefined)[]) {
  return locationArray
    .filter(place => Boolean(place))
    .join(", ") || NO_INFORMATION;
};
